<div class="crd-key-number-block">
    <p [innerHTML]="keyNumberBlock.text | translate | safe:'html'">

    </p>
</div>
